export class Validator {
	/* 		Usage:
				import { Validator } from "@/utils/validator";

				const validator = new Validator;
				const onInputChange = (e) => {
					validator.classicInput(e.target, value)
				}

				HTML
				div.form-input.validate
						label.form-label
						input.form-control
						div.feedback

				Na wraper inputa 'div.form-input.validate' dodavati klase po potrebi:
				.select - obavezno za react-select!
				.required - proverava da li input ima vrednost
				.field-email
				.field-phone
				.field-zip (zip inace ne koristimo, al postoji funkcija)
				.field-password
				.field-terms - dodato zbog drugacije poruke
	*/

	/*
	* Form submit validation
	*
	* pw - optional, used for registration form
	*/
	isFormDataValid(fd, pw = '', skipAddress = false, formId = null, country = '') {
		let addressKeys = [
			'companyName',
			'address',
			'address2',
			'city',
			'countryAbrv',
			'stateAbrv',
			'zipCode',
			'contactName',
			'contactPhone',
			'contactEmail'
		]
		let inputElements = []
		let formValid = true

		for (let [key, value] of fd.entries()) {
			if (skipAddress) {
				if (!addressKeys.find(element => element === key)) {
					let tmp = document.querySelector(`${formId ? formId : ''} [name="${key}"]`)
					inputElements.push(tmp)
					let isTmpValid = this.classicInput(tmp, value, pw, country)
					if (!isTmpValid) {
						formValid = false;
					}
				}
			} else {
				let tmp = document.querySelector(`${formId ? formId : ''} [name="${key}"]`)
				inputElements.push(tmp)
				let isTmpValid = this.classicInput(tmp, value, pw, country)
				if (!isTmpValid) {
					formValid = false;
				}
			}
		}

		return formValid
	}

	/*
	* API validation errors
	*
	*/
	markInvalidFeilds(invalidFields) {
		invalidFields.map((item) => {
			let input = document.querySelector(`input[name=${item.field}]`)
			let wrap = input.closest('.form-input')
			let feedback = wrap.querySelector('.feedback')

			if (wrap.classList.contains('select')) {
				let dynamic = wrap.querySelector('.dynamicSelect')
				dynamic.classList.add('is-invalid')
			}
			input.classList.add('is-invalid')
			feedback.innerText = getValueAndUseInSentence(item.field, item.error, item.value ? item.value : null)
			feedback.classList.add('invalid-feedback')
		})

		return true
	}




	/*
	* Input onChange validation
	*
	* confirmPassword - optional, used for registration form
	*/

	// Main method for validating fields
	classicInput(target, value, confirmPassword = '', country = '') {
		let input = target
		if (input.name == 'g-recaptcha-response') {
			return true;
		}
		let wrap = input.closest('.form-input')
		let feedback = wrap.querySelector('.feedback')

		if (wrap.classList.contains('validate')) {
			let valid = this.validateFormInput(value, wrap.classList, confirmPassword, country)

			if (!valid.valid) {
				if (wrap.classList.contains('select')) {
					let dynamic = wrap.querySelector('.dynamicSelect')
					dynamic.classList.add('is-invalid')
				}
				if (wrap.classList.contains('dpicker')) {
					let dpicker = wrap.querySelector('.react-datepicker-wrapper')
					dpicker.classList.add('is-invalid')
				}
				input.classList.add('is-invalid')
				feedback.innerText = valid.message
				feedback.classList.add('invalid-feedback')
				return false
			} else {
				input.classList.remove('is-invalid')
				feedback.innerText = valid.message
				feedback.classList.remove('invalid-feedback')
			}
		}
		return true
	}
	validateFormInput(value, classes, confirmPassword, country) {
		if (classes.contains('required') && classes.contains('field-terms')) {
			let valid = this.isEmpty(value)
			if (!valid) {
				return {
					'valid': false,
					'message': 'You must accept Terms & Conditions.'
				}
			}
		}
		if (classes.contains('required') && classes.contains('field-statement')) {
			let valid = this.isEmpty(value)
			if (!valid) {
				return {
					'valid': false,
					'message': 'You have to acknowledge this statement.'
				}
			}
		}

		if (classes.contains('required')) {
			let valid = this.isEmpty(value)
			if (!valid) {
				return {
					'valid': false,
					'message': 'This field is required.'
				}
			}
		}

		let tmpValid;
		const fieldClasses = [];
		for (const className of classes) {
			if (className.startsWith('field-')) {
				fieldClasses.push(className);
			}
		}

		for (const className of fieldClasses) {
			switch (className) {
				// Email
				case 'field-email':
					tmpValid = this.isEmail(value)
					return {
						'valid': tmpValid,
						'message': tmpValid ? '' : 'Email format is invalid.'
					}

				// Phone
				case 'field-phone':
					tmpValid = this.isPhone(value)
					return {
						'valid': tmpValid,
						'message': tmpValid ? '' : 'Phone format is invalid.'
					}

				// Phone - NOT REQUIRED ONLY IF NOT EMPTY
				case 'field-phone-no-req':
					if (this.isEmpty(value)) {
						tmpValid = this.isPhone(value)
						return {
							'valid': tmpValid,
							'message': tmpValid ? '' : 'Phone format is invalid.'
						}
					}
					return {
						'valid': true,
						'message': ''
					}

				// Zip code
				case 'field-zip':
					tmpValid = this.isZipCode(value, country)
					return {
						'valid': tmpValid,
						'message': tmpValid ? '' : 'Zip format is invalid.'
					}

				// Password
				case 'field-password':
					let tmpMessage = this.isPassword(value)
					return {
						'valid': tmpMessage ? false : true,
						'message': tmpMessage
					}

				case 'field-confirm-password':
					tmpValid = value === confirmPassword
					return {
						'valid': tmpValid,
						'message': tmpValid ? '' : 'Passwords do not match.'
					}

				case 'field-ccExpDate':
					tmpValid = this.isValidCreditCardExpirationDate(value)
					if (tmpValid) {
						tmpValid = this.isExpiredCreditCardDate(value)
						return {
							'valid': tmpValid,
							'message': tmpValid ? '' : 'Expiration date is expired.'
						}
					}
					return {
						'valid': tmpValid,
						'message': tmpValid ? '' : 'Expiration date is invalid.'
					}

				default:
					break
			}
		}

		// na kraju ako je sve ok
		return {
			'valid': true,
			'message': ''
		}
	}

	// Clear validation error for DynamicSelect component
	clearDynamicSelectError(name) {
		let hiddenInput = document.querySelector('input[name="' + name + '"]')
		let wrap = hiddenInput.closest('.form-input')
		let dynamic = wrap.querySelector('.dynamicSelect')
		let feedback = wrap.querySelector('.feedback')

		dynamic.classList.remove('is-invalid')
		feedback.classList.remove('invalid-feedback')
		feedback.innerText = ''
	}

	clearDatePickerError(name) {
		let hiddenInput = document.querySelector('input[name="' + name + '"]')
		let wrap = hiddenInput.closest('.form-input')
		let picker = wrap.querySelector('.react-datepicker-wrapper')
		let feedback = wrap.querySelector('.feedback')

		picker.classList.remove('is-invalid')
		feedback.classList.remove('invalid-feedback')
		feedback.innerText = ''
	}

	// clear all validation errors inside .className
	clearAllErrors(className) {
		const clearingWrap = document.querySelector(`.${className}`)
		const inputs = clearingWrap.querySelectorAll('input')

		inputs.forEach(element => {
			let wrap = element.closest('.form-input')
			let feedback = wrap.querySelector('.feedback')

			if (wrap.classList.contains('validate')) {

				if (wrap.classList.contains('select')) {
					let dynamic = wrap.querySelector('.dynamicSelect')
					dynamic.classList.remove('is-invalid')
				}
				element.classList.remove('is-invalid')
				feedback.innerText = ''
				feedback.classList.remove('invalid-feedback')
			}

		});
		// pokupim sve inpute
		// svaki input koji ima validate, uzmem i obrisem

	}
	/*
	* Helper functions
	*/

	isEmpty(value) {
		if (value.trim().length > 0) {
			return true;
		}
		return false;
	}

	isZipCode(value, country) {
		if (country != 'US') {
			return true
		}
		let validRegex = /^\d{5}(?:-\d{4})?$/;
		if (value.match(validRegex)) {
			return true;
		} else {
			return false;
		}
	}

	isEmail(value) {
		let email = value.trim();
		const regex = /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!\-#$%&'*+/=?^_`{|}~\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z]){2,63})+)$/i;
		const lastDotIndex = email.lastIndexOf('.');
		const stringWithOneCharBeforeLastDot = email.substring(lastDotIndex - 1);

		// check if there is a - before last . example test@test-.com is invalid
		if (email && !stringWithOneCharBeforeLastDot.includes('-')) {
			return regex.test(email);
		}

		return false;
	}

	isPhone(value) {
		const phone = value.trim(value.replace(' ', ''))
		const regExp = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

		if (!phone.match(regExp)) {
			return false
		} else {
			return true
		}
	}

	isPassword(value) {
		let validRegex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
		if (value.length < 8) {
			return "Password must be at least 8 characters.";

		} else if (!value.match(validRegex)) {
			let msg = "Password must contain at least one";
			let addComma = false;
			// check if thre is one number
			if (!value.match(/(?=.*[0-9])/)) {
				msg += " number";
				addComma = true;
			}
			if (!value.match(/(?=.*[a-z])/)) {
				if (addComma) {
					msg += ",";
				} else {
					addComma = true;
				}
				msg += " lowercase letter";
			}
			if (!value.match(/(?=.*[A-Z])/)) {
				if (addComma) {
					msg += ",";
				} else {
					addComma = true;
				}
				msg += " uppercase letter";
			}
			return msg + '.';
		}
		return "";
	}

	formatPhoneNumber(value) {
		if (!value) return value;
		const phoneNumber = value.replace(/[^\d]/g, "");
		const phoneNumberLength = phoneNumber.length;
		if (phoneNumberLength < 4) return phoneNumber;
		if (phoneNumberLength < 7) {
			return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
		}
		return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
			3,
			6
		)}-${phoneNumber.slice(6, 10)}`;
	}

	formatCity(value) {
		if (!value) return value;
		return value.replace(/[^A-Za-z0-9 ]+/gi, "");
	}


	formatCreditCardExpirationDate(value, oldValue) {
		if (!value) return value;

		let newValue = value.replace(/[^\d]/g, '');
		oldValue = oldValue.replace(/[^\d]/g, '');
		if (newValue.length < oldValue.length) {
			const minLength = Math.min(newValue.length, oldValue.length);

			let index;
			for (index = 0; index < minLength; index++) {
				if (newValue[index] !== oldValue[index]) {
					break; // Found the first different character
				}
			}

			newValue = newValue.slice(0, index);
		}

		newValue = newValue.slice(0, 4)
		if (newValue.length > 2) {
			newValue = newValue.slice(0, 2) + '/' + newValue.slice(2);
		}
		return newValue;
	}

	isValidCreditCardExpirationDate(value) {
		const date = value.trim(value.replace(' ', ''))
		const regExp = /(0[1-9]|1[0-2])\/?([0-9]{2})$/;

		if (!date.match(regExp)) {
			return false
		} else {
			return true
		}
	}

	isExpiredCreditCardDate(value) {
		const currentYear = new Date().getFullYear() % 100; // Get last two digits of the current year
		const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
		const [inputMonth, inputYear] = value.split('/').map(Number);

		if (inputYear < currentYear || (inputYear === currentYear && inputMonth < currentMonth)) {
			return false;
		}
		return true;
	};

}


// api validation codes
function getValueAndUseInSentence(field, error, value = null) {
	const capitalizeFirstLetter = (inputString) => `${inputString.charAt(0).toUpperCase()}${inputString.slice(1)}`;
	let msg = errorCodeDictionary[error];
	field = prettyFieldName[field]

	if (msg !== undefined) {
		msg = msg.replace('{field}', field)
		msg = value ? msg.replace('{value}', value) : msg

		return capitalizeFirstLetter(msg);
	} else {
		return `Error code '${error}' not found in the dictionary.`;
	}
}

const errorCodeDictionary = {
	wrong_format: '{field} format is wrong.',
	invalid: 'Incorrect value for {field}. Allowed values: {value}.',
	mandatory: '{field} is mandatory.',
	required: '{field} is required.',
	max_length: '{field} cannot be more then {value} characters long.',
	min_length: '{field} cannot be less then {value} characters long.',
	not_valid: '{field} - wrong format.',
	exists: '{field} already exists!',
	min_value: '{field} must be greater then {value}.',
	max_value: '{field} must be less then {value}.',
	daily_limit: 'You reached daily limit.',
	not_match: '{field} is wrong.'
}
const prettyFieldName = {
	address: "address",
	address2: "Address 2",
	city: "city",
	companyName: "company name",
	country: "country",
	countryAbrv: "country",
	email: 'email',
	contactEmail: 'email',
	name: 'name',
	contactName: "name",
	firstName: "first name",
	lastName: "last name",
	dock: 'dock',
	instructions: 'instructions',
	timezone: 'timezone',
	pickupDate: 'pickup date',
	numberOfPallets: 'Number of Pallets',
	pickupHoursFrom: 'pickup hours from',
	pickupHoursTo: 'pickup hours to',
	labelDoor: 'Label/Door',
	password: "password",
	newPassword: "password",
	phoneNo: "phone number",
	phone: "phone number",
	contactPhone: "phone number",
	shipToCode: 'location',
	state: "state",
	stateAbrv: "state",
	termsAccepted: 'terms & Conditions',
	zip: "zip code",
	zipCode: "zip code",
};